var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_6808)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1455_6808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 9.20166C5.12544 9.20166 4.44716 9.48261 3.94706 9.98271C3.44697 10.4828 3.16602 11.1611 3.16602 11.8683V24.6683C3.16602 25.3756 3.44697 26.0538 3.94706 26.5539C4.44716 27.054 5.12544 27.335 5.83268 27.335H7.43268C7.57413 27.335 7.70979 27.3912 7.80981 27.4912C7.90983 27.5912 7.96602 27.7269 7.96602 27.8683V31.6177C7.96685 31.7144 7.9946 31.8091 8.04615 31.891C8.0977 31.9729 8.17102 32.0389 8.25792 32.0815C8.34481 32.1241 8.44185 32.1417 8.53817 32.1323C8.6345 32.1229 8.72632 32.0869 8.80335 32.0283L14.7553 27.4459C14.8486 27.3741 14.963 27.3351 15.0807 27.335H27.166C27.8733 27.335 28.5515 27.054 29.0516 26.5539C29.5517 26.0538 29.8327 25.3756 29.8327 24.6683V11.8683C29.8327 11.1611 29.5517 10.4828 29.0516 9.98271C28.5515 9.48261 27.8733 9.20166 27.166 9.20166H5.83268Z",
    fill: "url(#paint0_linear_1455_6808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6474 2.38429L26.2352 14.3752C26.4781 14.7593 26.6134 15.2015 26.627 15.6558C26.6405 16.11 26.5319 16.5596 26.3123 16.9574C26.0927 17.3553 25.7702 17.6869 25.3787 17.9175C24.9871 18.1482 24.5408 18.2694 24.0864 18.2686H8.91089C8.45645 18.2694 8.01013 18.1482 7.61857 17.9175C7.227 17.6869 6.90458 17.3553 6.68499 16.9574C6.4654 16.5596 6.35671 16.11 6.37027 15.6558C6.38383 15.2015 6.51916 14.7593 6.76209 14.3752L14.3498 2.38429C14.5793 2.022 14.8966 1.72361 15.2723 1.51685C15.6479 1.31008 16.0698 1.20166 16.4986 1.20166C16.9275 1.20166 17.3493 1.31008 17.725 1.51685C18.1007 1.72361 18.418 2.022 18.6474 2.38429Z",
    fill: "url(#paint1_linear_1455_6808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4983 16.1358C17.0874 16.1358 17.565 15.6582 17.565 15.0691C17.565 14.48 17.0874 14.0024 16.4983 14.0024C15.9092 14.0024 15.4316 14.48 15.4316 15.0691C15.4316 15.6582 15.9092 16.1358 16.4983 16.1358Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 11.8683C16.2116 11.8683 15.9318 11.7592 15.7181 11.5626C15.5044 11.366 15.3724 11.0963 15.3483 10.8069L15.0363 7.0624C15.0194 6.85961 15.0448 6.65552 15.1108 6.46303C15.1767 6.27053 15.2819 6.0938 15.4196 5.944C15.5573 5.7942 15.7246 5.67458 15.9109 5.5927C16.0972 5.51082 16.2984 5.46844 16.5019 5.46826C16.7055 5.46822 16.907 5.51043 17.0934 5.59222C17.2799 5.67401 17.4474 5.79359 17.5853 5.94341C17.7232 6.09324 17.8285 6.27004 17.8946 6.46265C17.9606 6.65526 17.986 6.85947 17.9691 7.0624L17.6571 10.8069C17.633 11.0966 17.5008 11.3665 17.2868 11.5632C17.0728 11.7598 16.7926 11.8687 16.5019 11.8683Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50247 21.4685H6.90247C6.76103 21.4685 6.62537 21.4123 6.52535 21.3123C6.42533 21.2123 6.36914 21.0766 6.36914 20.9352C6.36914 20.7937 6.42533 20.6581 6.52535 20.5581C6.62537 20.458 6.76103 20.4019 6.90247 20.4019H8.50247C8.64392 20.4019 8.77958 20.458 8.8796 20.5581C8.97962 20.6581 9.03581 20.7937 9.03581 20.9352C9.03581 21.0766 8.97962 21.2123 8.8796 21.3123C8.77958 21.4123 8.64392 21.4685 8.50247 21.4685Z",
    fill: "#8991A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3052 24.135H19.7052C19.5638 24.135 19.4281 24.0788 19.3281 23.9788C19.2281 23.8788 19.1719 23.7431 19.1719 23.6017C19.1719 23.4602 19.2281 23.3246 19.3281 23.2246C19.4281 23.1245 19.5638 23.0684 19.7052 23.0684H21.3052C21.4467 23.0684 21.5823 23.1245 21.6823 23.2246C21.7824 23.3246 21.8385 23.4602 21.8385 23.6017C21.8385 23.7431 21.7824 23.8788 21.6823 23.9788C21.5823 24.0788 21.4467 24.135 21.3052 24.135Z",
    fill: "#8991A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4368 21.4685H10.6368C10.4954 21.4685 10.3597 21.4123 10.2597 21.3123C10.1597 21.2123 10.1035 21.0766 10.1035 20.9352C10.1035 20.7937 10.1597 20.6581 10.2597 20.5581C10.3597 20.458 10.4954 20.4019 10.6368 20.4019H23.4368C23.5783 20.4019 23.714 20.458 23.814 20.5581C23.914 20.6581 23.9702 20.7937 23.9702 20.9352C23.9702 21.0766 23.914 21.2123 23.814 21.3123C23.714 21.4123 23.5783 21.4685 23.4368 21.4685Z",
    fill: "#8991A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5691 24.135H6.90247C6.76103 24.135 6.62537 24.0788 6.52535 23.9788C6.42533 23.8788 6.36914 23.7431 6.36914 23.6017C6.36914 23.4602 6.42533 23.3246 6.52535 23.2246C6.62537 23.1245 6.76103 23.0684 6.90247 23.0684H17.5691C17.7106 23.0684 17.8462 23.1245 17.9463 23.2246C18.0463 23.3246 18.1025 23.4602 18.1025 23.6017C18.1025 23.7431 18.0463 23.8788 17.9463 23.9788C17.8462 24.0788 17.7106 24.135 17.5691 24.135Z",
    fill: "#8991A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1018 21.4685H25.5685C25.427 21.4685 25.2914 21.4123 25.1914 21.3123C25.0913 21.2123 25.0352 21.0766 25.0352 20.9352C25.0352 20.7937 25.0913 20.6581 25.1914 20.5581C25.2914 20.458 25.427 20.4019 25.5685 20.4019H26.1018C26.2433 20.4019 26.3789 20.458 26.4789 20.5581C26.579 20.6581 26.6352 20.7937 26.6352 20.9352C26.6352 21.0766 26.579 21.2123 26.4789 21.3123C26.3789 21.4123 26.2433 21.4685 26.1018 21.4685Z",
    fill: "#8991A0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_6808",
    x1: 4.49935,
    y1: 10.6685,
    x2: 29.8327,
    y2: 28.0018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB0B3",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_6808",
    x1: 12.4993,
    y1: 5.33512,
    x2: 25.8327,
    y2: 18.0018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF435A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_6808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.668945)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1455_6808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.668945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon1);
export default __webpack_public_path__ + "static/media/message_card_icon1.5658ec90875d0807cddf00dccbf93e66.svg";
export { ForwardRef as ReactComponent };